import type { JobsDetailData } from '@contracts'
import type { ToastDetails } from 'components/Banner/BannerTypesUtils.d'
import type { pdpTabIds, TabsObject } from 'components/Tabs/tabs-type.d'

export const returnEmptyPDPMessage = (status: JobsDetailData['status']) => {
  switch (status) {
    case 'processing':
    case 'executing':
      return "Content for this product is still being generated. The status will change to 'Pending approval' once it's available to view."
    case 'blocked':
      return 'Content for this product is blocked from generation'
    case 'failed':
      return 'Content for this product failed generation.'
    default:
      return ''
  }
}

export const tabsData: TabsObject[] = [
  { displayText: 'Content', view: 'content' },
  { displayText: 'Product data', view: 'product_data' },
  { displayText: 'Brand rules', view: 'brand_rules' },
  { displayText: 'Retailer rules', view: 'retailer_rules' },
  { displayText: 'Category rules', view: 'category_rules' },
]

export const DEFAULT_TAB = tabsData[0].view as pdpTabIds

export const SUCCESS_SUBMIT_BANNER: ToastDetails = {
  type: 'success',
  message: 'Task resubmitted successfully',
}
